import { useSelector } from "react-redux";

const usePermissions = () => {
  const { list: permissions, loading } = useSelector((state) => state.auth);

  const hasPermission = (myPermissions, operator) => {
    if (!permissions || !Array.isArray(permissions)) return false;
    if (!myPermissions) return null;

    if (!Array.isArray(myPermissions)) {
      myPermissions = [myPermissions];
    }

    if (operator === "or") {
      return permissions.some((permission) =>
        myPermissions.includes(permission)
      );
    } else {
      // Default to "and" logic if not specified or specified as "and"
      return myPermissions.every((permission) =>
        permissions.includes(permission)
      );
    }
  };

  return { loading, permissions: permissions || [], hasPermission };
};

export default usePermissions;
